import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SmallLoader from '../../../../shared/components/SmallLoader';
import Panel from '../CustomPanel';
import CustomTile from '../CustomTile';
import { colorsCombination } from '../../../../utils/helpers';
import CombineAreaChart from './CombineAreaChart';

const CombinedCamparison = ({ currentlyShow, dir }) => {
    const [amazonRevenues, setAmazonRevenues] = useState([]);
    const [shopifyRevenues, setShopifyRevenues] = useState([]);
    const [wholesaleRevenues, setWholesaleRevenues] = useState([]);

    const { amazonRevenueData, isAmazonRevenueLoading, isShopifyRevenueLoading, shopifyRevenueData,
        wholesaleRevenueData, isWholesaleRevenueLoading
    } = useSelector(({ dashboardReducer }) => ({
        amazonRevenueData: dashboardReducer.amazon.revenueData,
        isAmazonRevenueLoading: dashboardReducer.amazon.isLoading,
        shopifyRevenueData: dashboardReducer.shopify.revenueData,
        isShopifyRevenueLoading: dashboardReducer.shopify.isLoading,
        wholesaleRevenueData: dashboardReducer.wholesale.revenueData,
        isWholesaleRevenueLoading: dashboardReducer.wholesale.isLoading,
    }));

    useEffect(() => {
        setAmazonRevenues(amazonRevenueData?.modal?.data);
    }, [amazonRevenueData]);

    useEffect(() => {
        setShopifyRevenues(shopifyRevenueData?.modal?.data);
    }, [shopifyRevenueData]);

    useEffect(() => {
        setWholesaleRevenues(wholesaleRevenueData?.modal?.data);
    }, [wholesaleRevenueData]);

    const tileData = {
        total: { amount: 0, orderCount: 0 }, amazon: { amount: 0, orderCount: 0 },
        shopify: { amount: 0, orderCount: 0 },
        wholesale: { amount: 0, orderCount: 0 }
    };

    amazonRevenues?.forEach((revenue) => {
        if (revenue?.salesChannel !== 'Non-Amazon') {
            tileData.amazon.amount += Number(revenue.amount);
            tileData.amazon.orderCount += Number(revenue.orderCount)
        }

        tileData.total.amount += Number(revenue.amount);
        tileData.total.orderCount += Number(revenue.orderCount)
    });

    shopifyRevenues?.forEach((revenue) => {
        tileData.shopify.amount += Number(revenue.amount);
        tileData.shopify.orderCount += Number(revenue.orderCount)

        tileData.total.amount += Number(revenue.amount);
        tileData.total.orderCount += Number(revenue.orderCount)
    });

    wholesaleRevenues?.forEach((revenue) => {
        tileData.wholesale.amount += Number(revenue.amount);
        tileData.wholesale.orderCount += Number(revenue.orderCount)

        tileData.total.amount += Number(revenue.amount);
        tileData.total.orderCount += Number(revenue.orderCount)
    });

    return (<Row className="mt-4">
        <Panel lg={12} title="Revenue Comparison">

            <Row>
                {isAmazonRevenueLoading || isShopifyRevenueLoading ? (
                    <Col md={12} xl={3} lg={6} xs={12} className="mb-3"> <div
                        style={{ minHeight: '200px' }}
                        className="row align-items-center justify-content-center"
                    >
                        <SmallLoader loading={isAmazonRevenueLoading} />
                    </div>
                    </Col>
                ) : (
                    <CustomTile value={tileData?.total} title="Total Revenue" color={colorsCombination[0]} />)}
                {isAmazonRevenueLoading ? (
                    <Col md={12} xl={3} lg={6} xs={12} className="mb-3"> <div
                        style={{ minHeight: '200px' }}
                        className="row align-items-center justify-content-center"
                    >
                        <SmallLoader loading={isAmazonRevenueLoading} />
                    </div>
                    </Col>
                ) : (<CustomTile value={tileData?.amazon} title="Amazon Revenue" color={colorsCombination[1]} />)}
                {isShopifyRevenueLoading ? (
                    <Col md={12} xl={3} lg={6} xs={12} className="mb-3"> <div
                        style={{ minHeight: '200px' }}
                        className="row align-items-center justify-content-center"
                    >
                        <SmallLoader loading={isShopifyRevenueLoading} />
                    </div>
                    </Col>
                ) : (
                    <CustomTile value={tileData?.shopify} title="Shopify Revenue" />)}
                {isWholesaleRevenueLoading ? (
                    <Col md={12} xl={3} lg={6} xs={12} className="mb-3"> <div
                        style={{ minHeight: '200px' }}
                        className="row align-items-center justify-content-center"
                    >
                        <SmallLoader loading={isWholesaleRevenueLoading} />
                    </div>
                    </Col>
                ) : (<CustomTile value={tileData?.wholesale} title="Wholesale Revenue" />)}
            </Row >
            <CombineAreaChart currentlyShow={currentlyShow} dir={dir} />
        </Panel >
    </Row >)
}

CombinedCamparison.propTypes = {
    dir: PropTypes.string.isRequired,
    currentlyShow: PropTypes.objectOf({ key: "", value: "" }).isRequired
};
export default CombinedCamparison;